import axios from 'axios';
import React, { useEffect, useState } from 'react';
import '../../../../assets/css/bookings.css';
import '../../../../assets/css/filter.css';
import '../../../../assets/css/tables.css';
import iconFilter from '../../../../assets/icons/ic_filter.svg';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import ConfirmationModal from '../../common/ConfirmationModal';
import SimpleLoader from '../../common/SimpleLoader';
import PaginationController from '../../common/pagination_controller/PaginationController';
import SortOptionsSelector from '../../common/sort_options/SortOptionsSelector';
import { deleteOfflineBooking } from '../provider_calendar/networking';
import BookingItem from './BookingItem';
import BookingDetails from './booking_details/BookingDetails';
import FilterDialog from './booking_list/FilterDialog';
import SearchInput from './booking_list/SearchInput';
import { getBookingDetails, getUpcomingBookings } from './networking';
import { useHistory } from 'react-router-dom';
import { NavigatorPaths } from '../../../../assets/dictionaries/NavigatorPaths';
import CancelBookingDialog from "./booking_details/CancelBookingDialog";
import IconButton from '../atom/IconButton';
import useClientWidth from '../../../../utilities/hooks/useClientWidth';
{
	/*import iconSetting from '../../../../assets/icons/ic_setting.svg'; */
}
import ColumnSelector from './booking_table_columns/bookingTableColumns';
import { useAccount } from '../../../../utilities/hooks/UseAccount';
import { useSubscription } from '../../../../utilities/hooks/useSubscription';
import { useUpgradeToBusinessPlan } from '../../../../utilities/hooks/useUpgradeToBusinessPlan';
import NewBookingDialog from '../provider_calendar/NewBookingDialog';
import PremiumBadge from '../../common/PremiumBadge';

const Bookings = () => {
	const dictionary = useDictionary();
	const clientWidth = useClientWidth();
	const [selectedBooking, setSelectedBooking] = useState(null);
	const [showDeleteDialog, setDeleteDialogVisibility] = useState(false);
	const [showLoader, setShowLoader] = useState(true);
	const [bookings, setBookings] = useState(null);
	const [selectedOption, setSelectedOption] = useState(localStorage.getItem('bookings_selected_sort_type') ? JSON.parse(localStorage.getItem('bookings_selected_sort_type')) : {value: 'created_at', direction: 'desc', label: 'Newest'});
	const [searchParam, setSearchParam] = useState('');
	const [showScheduleDialog, setShowScheduleDialog] = useState(false);
	const [createDateParam, setCreateDateParam] = useState('');
	const [filterCount, setFilterCount] = useState(0);
	const [filterStatusParams, setFilterStatusParams] = useState([]);
	const [filterPaymentStatusParams, setFilterPaymentStatusParams] = useState([]);
	const [filterChannelParams, setFilterChannelParams] = useState([]);
	const [showFilter, setShowFilter] = useState(false);
	const [showCancelDialog, setCancelDialogVisibility] = useState(false);
	const LOCAL_STORAGE_KEY_TEXT = 'columnDynamicallyVisibilitySettings'
	const columnsConfig = {
		"#": { fixed: true, visible: true },
		[dictionary.create_date]: { fixed: false, visible: true },
		[dictionary.status]: { fixed: true, visible: true },
		[dictionary.customer]: { fixed: false, visible: true },
		[dictionary.Spots]: { fixed: false, visible: true },
		[dictionary.channel]: { fixed: false, visible: true },
		[dictionary.experience]: { fixed: false, visible: true },
		[dictionary.start_time]: { fixed: false, visible: true },
		[dictionary.end_time]: { fixed: false, visible: false },
		[dictionary.collection]: { fixed: false, visible: false },
		[dictionary.rating]: { fixed: false, visible: true },
		[dictionary.payment]: { fixed: false, visible: true },
		[dictionary.amount]: { fixed: true, visible: true },
	  };
	const [columns, setColumns] = useState(columnsConfig);

	const [pageSize, setPageSize] = useState(
		parseInt(localStorage.getItem('bookings_selected_page_size') ?? 10)
	);
	const [currentPage, setCurrentPage] = useState(0);
	const [dataLength, setDataLength] = useState(0);

	const source = axios.CancelToken.source();
	const history = useHistory();
	const account = useAccount();
	const isVerified = account?.verification_status?.value === '3';
	const isSubscription = useSubscription();
	const goToUpgrade = useUpgradeToBusinessPlan();
	const [showNewBookingDialog, setShowNewBookingDialog] = useState(false);
	const [showEditBookingDialog, setShowEditBookingDialog] = useState(false);
	const [editBookingDetails, setEditBookingDetails] = useState(null);

	const onOfflineBookingCreated = (booking) => {
		setShowNewBookingDialog(false);
		history.push(`/${NavigatorPaths.bookings.path}/${booking.id}`, booking);
	};

	useEffect(() => {
		countAllFilter();

		const date = localStorage.getItem('bookings_filter_date');
		setCreateDateParam(date);

		const statusIds =
			JSON.parse(localStorage.getItem('bookings_filter_status')) || [];
		setFilterStatusParams(statusIds);

		const paymentStatusIds =
			JSON.parse(localStorage.getItem('bookings_filter_payment_status')) || [];
		setFilterPaymentStatusParams(paymentStatusIds);

		const channelIds =
			JSON.parse(localStorage.getItem('bookings_filter_channel')) || [];
		setFilterChannelParams(channelIds);

		getBookingsAsync(source,{
			localDate: date,
			localStatusIds: statusIds,
			locaPaymentStatusIds: paymentStatusIds,
			localChannelIds: channelIds
		});
	}, [pageSize, currentPage, selectedOption, searchParam]);

	const onDeleteClicked = (booking) => {
		setSelectedBooking(booking);
		setDeleteDialogVisibility(true);
	};

	const onCancelClicked = (booking) => {
		setSelectedBooking(booking);
		setCancelDialogVisibility(true);
	};

	// Edit reuses NewBookingDialog in edit mode, which needs the full booking
	// (notes, participant_groups, experience assets) — the list row only
	// carries a subset, so fetch the detail before opening the dialog.
	const onEditClicked = async (booking) => {
		setShowLoader(true);
		try {
			const { data } = await getBookingDetails(booking.id);
			setEditBookingDetails(data);
			setShowEditBookingDialog(true);
		} catch (e) {
			console.error('Error fetching booking details:', e);
		} finally {
			setShowLoader(false);
		}
	};

	const deleteBookingAsync = async (onSuccess, onFail) => {
		try {
			await deleteOfflineBooking(selectedBooking.id);
			onSuccess();
		} catch (error) {
			onFail();
		}
	};

	useEffect(() => {
		return () => {
			source.cancel('component unmounted');
		};
	}, []);

	const getBookingsAsync = async (sorce, localData = {}) => {
		setShowLoader(true);
		try {
			const handleBookingsResponse = (data) => {
				setBookings(data.data);
				setDataLength(data.recordsFiltered ?? data.recordsTotal ?? 0);
				// if (data.data.length > 0) {
					setShowFilter(true);
				// }
				setShowLoader(false);
			};
			const params = localData && Object.keys(localData).length > 0
				? [
					selectedOption,
					pageSize,
					currentPage,
					false,
					source.token,
					searchParam,
					localData.localDate,
					localData.localStatusIds,
					localData.locaPaymentStatusIds,
					localData.localChannelIds
					]
				: [
					selectedOption,
					pageSize,
					currentPage,
					false,
					source.token,
					searchParam,
					createDateParam,
					filterStatusParams,
					filterPaymentStatusParams,
					filterChannelParams
				];
			const { data } = await getUpcomingBookings(...params);
			
			handleBookingsResponse(data);
		} catch (e) {
			console.error("Error fetching bookings:", e);
		} finally {
			setShowLoader(false);
		}
	};

	const getBookingsAsyncNoParams = async () => {
		setShowLoader(true);
		try {
			let { data } = await getUpcomingBookings(
				selectedOption,
				pageSize,
				currentPage,
				false,
				source.token
			);
			setBookings(data.data);
			setDataLength(data.recordsFiltered ?? data.recordsTotal ?? 0);
			setShowLoader(false);
		} catch (e) {
			setShowLoader(false);
		}
	};

	const onBookingClicked = (booking) => {
		history.push(`/${NavigatorPaths.bookings.path}/${booking.id}`);
	};

	const dismissDetails = () => {
		setTimeout(() => {
			// setDetailsVisibility(false);
			setSelectedBooking(null);
		}, 300);
		getBookingsAsync();
	};

	const onPagingParameterChanged = (type, newParameter) => {
		if (type === 'page') {
			setCurrentPage(newParameter);
		} else if (type === 'page-size') {
			setPageSize(newParameter);
		}
	};

	const onSortOptionValueChanged = (option) => {
		if(option.value !== selectedOption.value){
			setSelectedOption(option);
		}
	};

	const onSearchValueChanged = (value) => {
		setSearchParam(value);
	};

	const onCreateDateValueChanged = (date) => {
		countAllFilter();
		setCreateDateParam(date);
	};

	const onStatusValuesChanged = () => {
		countAllFilter();
	};

	const onPaymentStatusValuesChanged = () => {
		countAllFilter();
	};

	const onChannelValuesChanged = () => {
		countAllFilter();
	};


	const countAllFilter = () => {
		const dateFilter = localStorage.getItem('bookings_filter_date');
		const statusIds =
			JSON.parse(localStorage.getItem('bookings_filter_status')) || [];
		const paymentStatusIds =
			JSON.parse(localStorage.getItem('bookings_filter_payment_status')) || [];
		const channelIds =
			JSON.parse(localStorage.getItem('bookings_filter_channel')) || [];
		let filterCountAll = 0;
		if (dateFilter) {
			filterCountAll += 1;
		}

		filterCountAll += statusIds.length;
		filterCountAll += paymentStatusIds.length;
		filterCountAll += channelIds.length;
		setFilterCount(filterCountAll);
	};

	const showScheduleDialogWithMode = () => {
		setShowScheduleDialog(true);
	};

	const toggleColumnVisibility = (col) => {
		const updatedColumns = {
			...columns,
			[col]: { ...columns[col], visible: !columns[col].visible },
		};
		setColumns(updatedColumns);
		localStorage.setItem(LOCAL_STORAGE_KEY_TEXT, JSON.stringify(updatedColumns));
	};

	useEffect(() => {
		const savedSettings = localStorage.getItem(LOCAL_STORAGE_KEY_TEXT);
		if (savedSettings) {
			if(savedSettings.includes('Rating')) {
				setColumns(JSON.parse(savedSettings));
			} else {
				setColumns(columnsConfig);
                localStorage.setItem(LOCAL_STORAGE_KEY_TEXT, JSON.stringify(columnsConfig));
			}
		} else {
			localStorage.setItem(LOCAL_STORAGE_KEY_TEXT, JSON.stringify(columnsConfig));
		}
	}, []);

	return (
		<div
			className="calendar-container provider-booking-container"
			style={{
				position: 'relative',
				background: 'var(--background-color)',
				paddingTop: '0'
			}}
		>
			{clientWidth > 662 ? (
				<div className={`${isVerified ? 'booking-header-container' : 'booking-header-container flex-direction-row items-center'}`}>
					<div className="d-flex items-center">
						<h2 className="title-main" data-testid="bookings-header">
							{dictionary.bookings}
						</h2>
						{isVerified && (
							<div className="d-flex items-center" style={{ marginLeft: '24px' }}>
								<button
									className={`button has-premium-badge${
										!isSubscription ? ' button--locked' : ''
									}`}
									onClick={() =>
										isSubscription
											? setShowNewBookingDialog(true)
											: goToUpgrade()
									}
								>
									<div className={isSubscription ? 'plus-icon' : 'plus-dark-icon'} />
									{dictionary.create_new_booking}
									{!isSubscription ? <PremiumBadge /> : null}
								</button>
							</div>
						)}
					</div>
					{showFilter ? (
						<div className="booking-right-group booking-right-group-after">
							<div className={`${isVerified ? 'booking-right-filter-sort' : 'booking-right-filter-sort user-unverified'}`}>
								{
									isVerified ? (
										<>
											<SearchInput onValueChanged={onSearchValueChanged} />
											
											<IconButton onClickIcon={showScheduleDialogWithMode} activeState={showScheduleDialog}>
												<div className="booking-filter">
													<img className="icon-filter" src={iconFilter} />
													{filterCount > 0 ? (
														<span>
															{dictionary.filters} ({filterCount})
														</span>
													) : (
														<span>{dictionary.filters}</span>
													)}
												</div>
											</IconButton>
											<SortOptionsSelector
												onValueChanged={onSortOptionValueChanged}
												name={'bookings'}
											/>
										</>
									) : null
								}
								<ColumnSelector columns={columns} onChange={toggleColumnVisibility} />
							</div>
						</div>
					) : null}
				</div>
			) : null}
			{clientWidth <= 662 ? (
				<div className="booking-mobile-header-container">
					<div className="booking-mobile-header-top">
						<div className="d-flex items-center">
							<h2 className="title-main">{dictionary.bookings}</h2>
							{isVerified && (
								<button
									className={`button calendar-title-button has-premium-badge${
										!isSubscription ? ' button--locked' : ''
									}`}
									style={{ marginLeft: '12px' }}
									onClick={() =>
										isSubscription
											? setShowNewBookingDialog(true)
											: goToUpgrade()
									}
								>
									<div className={isSubscription ? 'plus-icon' : 'plus-dark-icon'} />
									<span className="calendar-title-button-text">{dictionary.create_new_booking}</span>
									{!isSubscription ? <PremiumBadge /> : null}
								</button>
							)}
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							{
								isVerified ? (
									<>
										<div
											className="booking-filter"
											onClick={() => {
												showScheduleDialogWithMode();
											}}
										>
											<img className="icon-filter" src={iconFilter} />
											<span className="booking-filter-label">
												{filterCount > 0
													? `${dictionary.filters} (${filterCount})`
													: dictionary.filters}
											</span>
											{filterCount > 0 && (
												<span className="booking-filter-count">{filterCount}</span>
											)}
										</div>
										<SortOptionsSelector
											onValueChanged={onSortOptionValueChanged}
											name={'bookings'}
										/>
									</>
								) : null
							}
							{isVerified && clientWidth > 375 ? (
								<ColumnSelector columns={columns} onChange={toggleColumnVisibility} />
							) : null}
							{!isVerified ? (
								<ColumnSelector columns={columns} onChange={toggleColumnVisibility} />
							) : null}
						</div>
					</div>
					{isVerified ? (
						<div className={`booking-mobile-header-bottom ${clientWidth <= 375 ? ' booking-mobile-coloumn-selector' : ''}`}>
							<SearchInput onValueChanged={onSearchValueChanged} />
							{clientWidth <= 375 ? (
								<ColumnSelector columns={columns} onChange={toggleColumnVisibility} />
							) : null}
						</div>
					) : null}
				</div>
			) : null}
			<div className="upiria-table-container booking-table-container">
				<div className="upiria-table-header-strip" />
				<div className="upiria-table-container-inner thin-scrollbar-trans">
					<table
						data-testid="bookings-table"
						cellSpacing="0"
						cellPadding="0"
						border="0"
						className="upiria-table-container-bookings-table"
					>
						<thead>
						<tr>
							{Object.keys(columns).map(
								(col) => columns[col].visible && <th key={col}>{col}</th>
							)}
						</tr>
						</thead>
						<tbody>
						{bookings?.map((item) => (
							<BookingItem
								key={item.id}
								columns={columns}
								onBookingClicked={onBookingClicked}
								onDeleteClicked={onDeleteClicked}
								onCancelClicked={onCancelClicked}
								onEditClicked={onEditClicked}
								item={item}
							/>
						))}
						</tbody>
					</table>
				</div>

				{bookings?.length === 0 ? (
					<div
						className="empty-experiences-list-wrapper"
						style={{ height: '80%' }}
					>
						<div className="empty-experiences-list-placeholder">
							<div className="empty-experiences-image empty-bookings-image" />
							<h3
								data-testid="no-bookings-yet-header"
								style={{ textAlign: 'center', marginTop: '24px' }}
							>
								{dictionary.start_selling}
							</h3>
							<div style={{ marginTop: '8px' }} className="text">
								{dictionary.your_bookings_will_be_listed_here}
							</div>
						</div>
					</div>
				) : null}
			</div>
			{showLoader ? <SimpleLoader showLoader={showLoader} /> : null}
			{showDeleteDialog ? (
				<ConfirmationModal
					onActionFinished={() => getBookingsAsync()}
					setShowModal={setDeleteDialogVisibility}
					asyncTask={deleteBookingAsync}
					title={dictionary.delete_booking}
					message={dictionary.delete_booking_message}
					successMessage={dictionary.booking_deleted}
					errorMessage={dictionary.problem_deleting_booking}
					action={dictionary.delete}
				/>
			) : null}
			{showScheduleDialog ? (
				<FilterDialog
					onCreateDateValueChanged={onCreateDateValueChanged}
					onStatusValuesChanged={onStatusValuesChanged}
					onPaymentStatusValuesChanged={onPaymentStatusValuesChanged}
					onChannelValuesChanged={onChannelValuesChanged}
					setShowScheduleDialog={setShowScheduleDialog}
					filterCount={filterCount}
					countAllFilter={countAllFilter}
					getBookingsAsync={getBookingsAsync}
					getBookingsAsyncNoParams={getBookingsAsyncNoParams}
					setSearchParam={setSearchParam}
					setCreateDateParam={setCreateDateParam}
					setFilterStatusParams={setFilterStatusParams}
					setFilterPaymentStatusParams={setFilterPaymentStatusParams}
					setFilterChannelParams={setFilterChannelParams}
					setCurrentPage={setCurrentPage}
				/>
			) : null}
			<PaginationController
				name="bookings"
				onParameterChanged={onPagingParameterChanged}
				dataLength={dataLength}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
			{showCancelDialog && selectedBooking && (
				<CancelBookingDialog
					details={selectedBooking}
					dismissDetails={dismissDetails}
					setShow={setCancelDialogVisibility}
				/>
			)}
			{showNewBookingDialog ? (
				<NewBookingDialog
					setShowDialog={setShowNewBookingDialog}
					onBookingCreated={onOfflineBookingCreated}
				/>
			) : null}
			{showEditBookingDialog && editBookingDetails ? (
				<NewBookingDialog
					mode="edit"
					booking={editBookingDetails}
					setShowDialog={setShowEditBookingDialog}
					onBookingCreated={() => getBookingsAsync()}
				/>
			) : null}
		</div>
	);
};

export default Bookings;
